export default __webpack_public_path__ + "static/media/antp_coloquio_HumbertoVargas.11cb311f.png";